import { Button, ButtonGroup, Container, Stack } from "@chakra-ui/react";
import { useState } from "react";
import { ExpenseLimits } from "./ExpenseLimits";
import { SavingGoalsPage } from "./SavingGoalsPage";

export default function ExpenseSavingGoalsWrapper() {
  const [activeLimitOrGoal, setActiveLimitOrGoal] = useState<
    "limits" | "savings"
  >("limits");

  const renderAddLimitsOrSavings = () => {
    switch (activeLimitOrGoal) {
      case "limits":
        return <ExpenseLimits />;
      case "savings":
        return <SavingGoalsPage />;
      default:
        return null;
    }
  };
  return (
    <Container maxW="lg" py={10} pb={{ base: 24, md: 10 }}>
      <Stack spaceY={2} align="center">
        {/*   <Heading textAlign="center" mb={4} ml={4}>
          FineCheck ✅
        </Heading> */}
        <ButtonGroup attached variant="outline" colorScheme="teal" pt={5}>
          <Button
            onClick={() => setActiveLimitOrGoal("limits")}
            variant={activeLimitOrGoal === "limits" ? "solid" : "outline"}
          >
            Ausgabenlimits
          </Button>
          <Button
            onClick={() => setActiveLimitOrGoal("savings")}
            variant={activeLimitOrGoal === "savings" ? "solid" : "outline"}
          >
            Sparziele
          </Button>
        </ButtonGroup>
        <Stack spaceY={6}>{renderAddLimitsOrSavings()}</Stack>
      </Stack>
      {/* <Stack spaceY={6}>
        <Heading textAlign="center">FineCheck ✅</Heading>
        <ExpenseLimits />
        <SavingGoalsPage />
      </Stack> */}
    </Container>
  );
}
